
import { mapActions, mapGetters } from "vuex";
import i18n from "@/plugins/i18n";
import CSV from "@/components/templates/CSV.vue";
import CopyButton from "@/components/templates/CopyButton.vue";
import * as views from "@/plugins/utils/View";
import * as action from "@/store/actions";
import * as crud from "@/plugins/utils/Crud";
import Vue from "vue";
import { RoleGroup, View } from "@/types/conf";

export default Vue.extend({
  name: "RoleGroup",
  data: () => ({
    canDelete: false,
    canCreate: false,
    canUpdate: false,
    alertType: "",
    alertMessage: "",
    newAlert: 0,

    deletePermission: false,
    roleGroupList: [] as RoleGroup[],
    selectedRolegroup: null as RoleGroup | null,
    search: "",
    dialog: false,
    dialogDelete: false,
    loadingList: false,
  }),
  computed: {
    ...mapGetters({
      views: "auth/views",
      hoverColor: "lookAndFeel/hoverColor",
      menuIconColor: "lookAndFeel/menuIconColor",
      menuFontColor: "lookAndFeel/menuFontColor",
    }),
  },
  async mounted() {
    this.loadingList = true;
    this.roleGroupList = await this.getRoleGroupList(
      action.ROLE_GROUP_CONTROLLER
    );
    this.actionHandler();
    this.loadingList = false;
  },

  components: {
    CSV,
    CopyButton,
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    ...mapActions({
      getRoleGroupList: "crudService/getList",
      deleteRoleGroup: "crudService/deleteObject",
    }),
    headers() {
      return [
        {
          text: i18n.t("misc.name"),
          align: "start",
          sortable: false,
          value: "roleGroupName",
        },
        { text: i18n.t("configuration.user"), value: "users" },

        {
          text: i18n.t("misc.actions"),
          value: "actions",
          sortable: false,
          align: "left",
          width: "10%",
        },
      ];
    },
    actionHandler() {
      const view = this.views.find((v: View) => v.name == views.ROLEGROUP);
      if (view) {
        this.canDelete = view.actions.includes(crud.DELETE);
        this.canCreate = view.actions.includes(crud.CREATE);
        this.canUpdate = view.actions.includes(crud.UPDATE);
      }
    },
    editItem(item: RoleGroup) {
      this.navigateTo(item);
    },

    deleteItem(item: RoleGroup) {
      this.selectedRolegroup = item;
      this.deletePermission = item.users == 0;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      const response = !!this.selectedRolegroup
        ? await this.deleteRoleGroup({
            id: this.selectedRolegroup?.roleGroupId,
            action: action.ROLE_GROUP_CONTROLLER,
          })
        : null;
      this.closeDelete();
      if (response) {
        this.alertType = "green darken-1";
        this.alertMessage = ((i18n.t("misc.deleted") as string) +
          i18n.t("misc.defaultSuccess")) as string;
        let roleGroupListUpdated = [...this.roleGroupList];
        this.roleGroupList = roleGroupListUpdated.filter(
          (roleGroup) =>
            roleGroup.roleGroupId != this.selectedRolegroup?.roleGroupId
        );
      } else {
        this.alertType = "error";
        this.alertMessage = i18n.t("misc.defaultError") as string;
      }
      this.$store.dispatch("snackbar/showSnack", {
        message: this.alertMessage,
        color: this.alertType,
        timeout: 3000,
      });
    },

    closeDelete() {
      this.dialogDelete = false;
    },

    navigateTo(roleGroup: any) {
      if (roleGroup) {
        this.$router.replace({
          name: "rolegroup/update",
          params: { roleGroupToUpdate: roleGroup },
        });
      } else {
        this.$router.replace({
          name: "rolegroup/new",
        });
      }
    },
  },
});
